import React from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStyles } from './mecha_button_styles';

const MechaButton = (props) => {
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';
    const classes = useStyles({ isXs });
    const { buttonType, buttonStyle, buttonLabel, buttonSize, isDisabled, onClick, dataId, href, color, icon } = props;

    if (buttonType === 'link') {
        return (
            <a
                data-id={dataId}
                id={dataId}
                disabled={isDisabled}
                color={color}
                className={`${classes.center} ${classes[`mecha_text_button_${buttonSize}`]} ${classes.mecha_text_button} ${classes[`mecha_${color}`]}`}
                href={href}
            >
                {buttonLabel}
            </a>
        );
    }
    if (buttonType === 'error') {
        return (
            <a
                data-id={dataId}
                id={dataId}
                disabled={isDisabled}
                className={`${classes.center} ${classes[`mecha_${buttonStyle}_button_${buttonSize}`]} ${classes[`mecha_${buttonStyle}_button`]}`}
                href={href}
                onClick={(e) => {
                    if (!isDisabled) {
                        onClick(e);
                    }
                }}
            >
                {buttonLabel}
            </a>
        );
    }

    return (
        <>
            <button
                data-id={dataId}
                disabled={isDisabled}
                type="button"
                id={dataId}
                // hero / text button
                className={`${classes[`mecha_${buttonType}_button_${buttonSize}`]} ${classes[`mecha_${buttonType}_button`]}`}
                onClick={(e) => {
                    if (!isDisabled) {
                        onClick(e);
                    }
                }}
            >
                {icon && (
                    <span>
                        <FontAwesomeIcon icon={icon.icon} color={icon.color} fixedWidth={icon.fixedWidth} />
                    </span>
                )}
                {buttonLabel}
            </button>
        </>
    );
};

MechaButton.propTypes = {
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])]),
    buttonType: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonStyle: PropTypes.string,
    buttonSize: PropTypes.string,
    dataId: PropTypes.string,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    color: PropTypes.string,
    icon: PropTypes.object
};

export { MechaButton };
